import { __assign, __awaiter, __generator, __rest } from "tslib";
import { getAbsoluteUrl } from './services';
var OEMBED_URL = '/rich-content/oembed?url=';
var buildUrl = function (url) { return OEMBED_URL + getAbsoluteUrl(url); };
export var fetchOembed = function (url, instance) {
    return fetch(buildUrl(url), {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: instance,
        },
    }).then(function (res) { return res.json(); });
};
var providerBlackList = ['wix', 'facebook'];
export var fetchEmbedData = function (instance) { return function (url) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        try {
            return [2 /*return*/, fetchOembed(url, instance).then(function (json) {
                    var html = json.html, rest = __rest(json, ["html"]);
                    var provider_name = rest.provider_name;
                    var res = providerBlackList.includes((provider_name || '').toLowerCase())
                        ? __assign({}, rest) : __assign(__assign({}, rest), { html: html });
                    return res;
                })];
        }
        catch (e) {
            return [2 /*return*/, new Promise(function (resolve) {
                    setTimeout(function () { return resolve({}); }, 1);
                })];
        }
        return [2 /*return*/];
    });
}); }; };
//# sourceMappingURL=fetchEmbedData.js.map